//Projectpaymentduereport.js

import React, { Component } from 'react';
import { Navigate } from 'react-router-dom';
import axios from 'axios';
import Table from '@mui/material/Table';
import TableRow from '@mui/material/TableRow';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableSortLabel from '@mui/material/TableSortLabel';
import PropTypes from 'prop-types';
import TablePagination from '@mui/material/TablePagination';
import Button from '@mui/material/Button';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import dayjs from 'dayjs';
import TextField from '@mui/material/TextField';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import * as XLSX from 'xlsx';
import SearchIcon from '@mui/icons-material/Search';
import { saveAs } from 'file-saver';
import Autocomplete from '@mui/material/Autocomplete';
import Serverurl from './Apiurl';
import {
  Container,
  Paper,
  Box,
  Typography,
  Alert,
  CircularProgress
} from '@mui/material';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import PrintIcon from '@mui/icons-material/Print';

function desc(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) return -1;
    if (b[orderBy] > a[orderBy]) return 1;
    return 0;
}

function stableSort(array, cmp) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = cmp(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map(el => el[0]);
}

function getSorting(order, orderBy) {
    return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}

const headCells = [
    { id: 'Project', label: 'Project' },
    { id: 'FinalizedAmount', label: 'Finalized Amount' },
    { id: 'PaymentIn', label: 'Paid' },
    { id: 'Due', label: 'Due' },
];
function EnhancedTableHead(props) {
    const { order, orderBy, onRequestSort, rowCount, dynamicColumns } = props;
    const createSortHandler = property => event => {
        onRequestSort(event, property);
    };

    return (
        <TableHead>
            <TableRow>
                {headCells.map(headCell => (
                    <TableCell
                        key={headCell.id}
                        align={headCell.numeric ? 'right' : 'left'}
                        padding={headCell.disablePadding ? 'none' : 'default'}
                        sortDirection={orderBy === headCell.id ? order : false}
                    >
                        <TableSortLabel
                            active={orderBy === headCell.id}
                            direction={orderBy === headCell.id ? order : 'asc'}
                            onClick={createSortHandler(headCell.id)}
                        >
                            {headCell.label}
                        </TableSortLabel>
                    </TableCell>
                ))}
               
            </TableRow>
        </TableHead>
    );
}

EnhancedTableHead.propTypes = {
    onRequestSort: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
    dynamicColumns: PropTypes.array.isRequired,
};

export default class Projectpaymentduereport extends Component {
    constructor(props) {
        super(props);
        const currentDate = new Date();
        this.state = {
            redirect: false,
            pagename: '',          
            projectId: '',
            projectName: '',
            filteredProjects: [],
            loadingProjects: false,
            projects: [],
            projectarray: [],
            projectarrauto: [],
            selectedProject: null,
            reportData: [],
            grandTotalAmount: 0,
            loading: false,
            error: '',
            totalHeads: 0,
            totalAmount: 0,
            page: 0,
            rowsPerPage: 10,
            order: 'desc',
            orderBy: 'pj_id',
            dynamicColumns: [],
            openExportDialog: false,
        };
    }
fetchProjectData = () => {
    axios.get(Serverurl + "ajaxprojects.php?action=projectautoextender&projectname=")
    .then((resp) => {
        let strCust = [];
        (resp.data || []).forEach((row) => {
            const item = {
                pj_id: row.pj_id,
                pj_projectname: row.pj_projectname,
                rowindex: row.rowindex
            };
            const found = strCust.some((el) => el.pj_id === row.pj_id);
            if (!found) {
                strCust.push(item);
            }
        });
        this.setState({
            projectarray: resp.data || [],
            projectarrauto: strCust
        });
    })
    .catch(() => {
        this.setState({
            error: "Unable to fetch project data"
        });
    });
};

apicall = () => {
    this.setState({
        loading: true,
        error: ""
    });

    axios
        .get( Serverurl +
        "ajaxlaborexpensesreport.php?action=getprojectpaymentduereport" +
        "&project_id=" + this.state.projectId +
        "&index=" + this.state.page +
        "&maxrecrd=" + this.state.rowsPerPage )
        .then((resp) => {
            let data = Array.isArray(resp.data) ? resp.data : [];

            let totalDue = 0;

            data.forEach((item) => {
                totalDue += Number(item.Due || 0);
            });

            this.setState({
                reportData: data,
                grandTotalAmount: totalDue,
                totalRecords:
                    data.length > 0
                        ? parseInt(data[0].count || 0)
                        : 0,
                loading: false
            });
        })
        .catch(() => {
            this.setState({
                loading: false,
                error: "Unable to fetch report data"
            });
        });
};

searchProject = (event, value) => {
    this.setState({
        projectName: value,
        projectId: '',
        loadingProjects: true
    });

    if (!value || value.trim() === '') {
        this.setState({
            filteredProjects: [],
            loadingProjects: false
        });
        return;
    }

    axios
        .get(Serverurl + "ajaxprojects.php?action=projautoextender&pj_projectname=" + value)
        .then((response) => {
            this.setState({
                filteredProjects: response.data || [],
                loadingProjects: false
            });
        })
        .catch(() => {
            this.setState({
                loadingProjects: false
            });
        });
};
    componentDidMount() {
      


  if(localStorage.getItem("VRuserid")==null)
		  {

		   this.setState({
            redirect: true,
			pagename:'/Userlogin'
          })
		  }
let strname="Payments Pending In";   
			 this.props.parentsCallback(
           strname
        );
		
		document.title = "VR Builders - Payment Pending In";

        this.fetchProjectData();
        this.apicall();
    }
    selectProject = (event, value) => {
        this.setState({
            projectId: value ? value.pj_id : '',
            projectName: value ? value.pj_projectname : ''
        });
    };

    handleInputChange = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    };

    handleSearch = () => {
        this.setState({
            page: 0
        }, () => {
            this.apicall(0, this.state.rowsPerPage);
        });
    };

    handleRequestSort = (event, property) => {
        const isAsc = this.state.orderBy === property && this.state.order === 'asc';
        this.setState({
            orderBy: property,
            order: isAsc ? 'desc' : 'asc',
            page: 0
        }, () => {
            this.apicall(0, this.state.rowsPerPage);
        });
    };

    handleChangePage = (event, newPage) => {
        this.setState({ page: newPage }, () => {
            this.apicall(newPage, this.state.rowsPerPage);
        });
    };

    handleChangeRowsPerPage = event => {
        this.setState({
            page: 0,
            rowsPerPage: parseInt(event.target.value)
        }, () => {
            this.apicall(0, parseInt(event.target.value));
        });
    };
    handleOpenExportDialog = () => {
        this.setState({ openExportDialog: true });
    };

    handleCloseExportDialog = () => {
        this.setState({ openExportDialog: false });
    };
handleDownloadPDF = () => {
    const doc = new jsPDF("l", "mm", "a4");

    doc.setFontSize(14);
    doc.text("Customer payments pending", 14, 15);

    const rows = this.state.reportData.map((item) => [
        item.Project,
        Number(item.FinalizedAmount).toLocaleString("en-IN"),
        Number(item.PaymentIn).toLocaleString("en-IN"),
        Number(item.Due).toLocaleString("en-IN")
    ]);

    rows.push([
        "Grand Total",
        "",
        "",
        Number(this.state.grandTotalAmount).toLocaleString("en-IN")
    ]);

    doc.autoTable({
        head: [[
            "Project",
            "Finalized Amount",
            "Payment In",
            "Due Amount"
        ]],
        body: rows,
        startY: 25
    });

    doc.save("ProjectPaymentDueReport.pdf");
};
exportExcel = () => {

    let excelData = this.state.reportData.map((item) => ({
        Project: item.Project,
        FinalizedAmount: item.FinalizedAmount,
        PaymentIn: item.PaymentIn,
        Due: item.Due
    }));

    excelData.push({
        Project: "Grand Total",
        FinalizedAmount: "",
        PaymentIn: "",
        Due: this.state.grandTotalAmount
    });

    const ws = XLSX.utils.json_to_sheet(excelData);

    const wb = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(
        wb,
        ws,
        "Project Payment Due"
    );

    const buffer = XLSX.write(wb, {
        bookType: "xlsx",
        type: "array"
    });

    saveAs(
        new Blob([buffer], {
            type: "application/octet-stream"
        }),
        "ProjectPaymentDueReport.xlsx"
    );

    this.setState({
        openExportDialog: false
    });
};
  printReport = () => {
        window.print();
        this.setState({ openExportDialog: false });
    };

    render() {
        if (this.state.redirect) {
            return <Navigate to={this.state.pagename} />;
        }

        const { reportData, order, orderBy, page, rowsPerPage, totalRecords, openExportDialog, loading, error, dynamicColumns } = this.state;
        const visibleRows = stableSort(reportData, getSorting(order, orderBy));

        return (
            <React.Fragment>
              
              
                       

                        <div className="searchmaster">
                            <ul>
                            
                                <li>
               
                       
                                    <p>Project</p>
                                    <p> <Autocomplete className="inputcntlparent"
                                        fullWidth
                                        options={this.state.filteredProjects}
                                        value={
                                            this.state.filteredProjects.find(
                                                (x) => x.pj_id === this.state.projectId
                                            ) || null
                                        }
                                        getOptionLabel={(option) =>
                                            option.pj_projectname || ''
                                        }
                                        onInputChange={this.searchProject}
                                        onChange={this.selectProject}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                variant="outlined"
                                                fullWidth
                                                 size="small"
                                                placeholder="Search Project"
                                            />
                                        )}
                                    /></p>
                                </li>
                               
                                <li>
                                    <p>&nbsp;</p>
                                    <p> <Button variant="contained" className="exportbtn" onClick={this.handleSearch} endIcon={<SearchIcon />}>
                                        Search
                                    </Button>  <Button
                                        variant="contained"
                                        color="primary"
                                        className="exportbtn"
                                        onClick={this.handleOpenExportDialog}
                                    >
                                        EXPORT
                                    </Button></p>
                                </li>
                               
                            </ul>
                        </div>

                     
 <Paper sx={{ p: 3 }}>
                        <TableContainer>
                            <Table id="laborreport">
                                <EnhancedTableHead
                                    order={order}
                                    orderBy={orderBy}
                                    onRequestSort={this.handleRequestSort}
                                    rowCount={reportData.length}
                                    dynamicColumns={dynamicColumns}
                                />
                                <TableBody>
    {reportData.length === 0 ? (
        <TableRow>
            <TableCell colSpan={4} align="center">
                No Records
            </TableCell>
        </TableRow>
    ) : (
        reportData.map((item, index) => (
            <TableRow key={index}>
                <TableCell>
                    {item.Project}
                </TableCell>

                <TableCell>
                   Rs. {Number(item.FinalizedAmount).toLocaleString("en-IN")}
                </TableCell>

                <TableCell>
                    Rs. {Number(item.PaymentIn).toLocaleString("en-IN")}
                </TableCell>

                <TableCell>
                    Rs. {Number(item.Due).toLocaleString("en-IN")}
                </TableCell>
            </TableRow>
        ))
    )}

    {reportData.length > 0 && (
        <TableRow>
            

            <TableCell />

            <TableCell />
<TableCell>
                <b>Grand Total</b>
            </TableCell>
            <TableCell >
                <b>
                    Rs. {parseFloat(this.state.grandTotalAmount).toLocaleString("en-IN")}
                </b>
            </TableCell>
        </TableRow>
    )}
</TableBody>
                            </Table>
                        </TableContainer>

                        <TablePagination
                            rowsPerPageOptions={[10, 25, 50, 100]}
                            component="div"
                            count={totalRecords}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={this.handleChangePage}
                            onRowsPerPageChange={this.handleChangeRowsPerPage}
                        />
   </Paper>
                        <Dialog open={openExportDialog} onClose={this.handleCloseExportDialog}>
                            <DialogTitle>Export Labor Report</DialogTitle>
                            <DialogContent>
                                <p>Choose export format:</p>
                                <p style={{ textAlign: 'center', display: 'flex', justifyContent: 'center', gap: '20px' }}>
                                    <Button
                                        variant="contained"
                                        startIcon={<FileDownloadIcon />}
                                        onClick={this.exportExcel}
                                        sx={{
                                            backgroundColor: '#2e7d32',
                                            '&:hover': {
                                                backgroundColor: '#1b5e20'
                                            }
                                        }}
                                    >
                                        Excel
                                    </Button>
                                    <Button
                                        variant="contained"
                                        startIcon={<PictureAsPdfIcon />}
                                        onClick={this.handleDownloadPDF}
                                        sx={{
                                            backgroundColor: '#d32f2f',
                                            '&:hover': {
                                                backgroundColor: '#b71c1c'
                                            }
                                        }}
                                    >
                                        PDF
                                    </Button>
                                </p>
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={this.handleCloseExportDialog}>Cancel</Button>
                            </DialogActions>
                        </Dialog>
                 
             </React.Fragment>
        );
    }
}